/*
 * @Author: Liux
 * @Date: 2019-11-21 08:07:13
 * @LastEditor: Liux
 * @LastEditTime: 2020-05-20 16:43:45
 */
import { Component, OnInit, Input } from '@angular/core';

export enum DividerModel {
  Vertical,
  Horizon,
}

@Component({
  selector: 'ad-divider',
  templateUrl: './ad-divider.component.html',
  styleUrls: ['./ad-divider.component.scss'],
})
export class AdDividerComponent implements OnInit {
  @Input() model: DividerModel = DividerModel.Vertical;

  constructor() {}

  ngOnInit() {}

  isHorizon() {
    return this.model === DividerModel.Horizon;
  }
}
